// reload 3
// polyfills
import 'babel-polyfill';
import 'element-closest';
import './polyfill';

import './windowExports';

// source
import './web';
import './configureWeb';
import './configurePartialUpdate';

// css
import '../css-scss/main.scss';



// WEBPACK FOOTER //
// ./fe/web-bn/src/js/index.js